/**
 * The constants.ts module is used by next.config.ts and the other modules inside src/config
 * next.config.ts doesn't resolve transitive `@/` very well, so better keep this file clean of deps
 */

import type { PublicEnv } from "./publicEnvSchema";

export const FIREBLOCKS_ENV_VAR_NAMES = {
  dev: {
    apiBaseUrl: "FIREBLOCKS_API_BASE_URL_DEV",
    apiKey: "FIREBLOCKS_API_KEY_DEV",
    secretKey: "FIREBLOCKS_SECRET_KEY_DEV",
  },
  prod: {
    apiBaseUrl: "FIREBLOCKS_API_BASE_URL_PROD",
    apiKey: "FIREBLOCKS_API_KEY_PROD",
    secretKey: "FIREBLOCKS_SECRET_KEY_PROD",
  },
  staging: {
    apiBaseUrl: "FIREBLOCKS_API_BASE_URL_STAGING",
    apiKey: "FIREBLOCKS_API_KEY_STAGING",
    secretKey: "FIREBLOCKS_SECRET_KEY_STAGING",
  },
  testing: {
    apiBaseUrl: "FIREBLOCKS_API_BASE_URL_STAGING",
    apiKey: "FIREBLOCKS_API_KEY_STAGING",
    secretKey: "FIREBLOCKS_SECRET_KEY_STAGING",
  },
} as const satisfies Record<
  PublicEnv["NEXT_PUBLIC_ENVIRONMENT_TYPE"],
  Record<"apiBaseUrl" | "apiKey" | "secretKey", string>
>;

/**
 * Proxy path used by Next.js rewrites to forward PostHog requests.
 * Configured in next.config.js to rewrite to PostHog's ingest servers.
 */
export const POSTHOG_PROXY_PATH = "/river-Bk4sN9xT";
